import { decodeAuthToken } from "../components/utils";
import { useAuthStore } from "../store";

const BILLING_USER_EMAILS = new Set([
  "rina@rulezero.com",
  "kiran@rulezero.com",
  "gourav@rulezero.com",
  "jayanth@rulezero.com",
  "karthik@rulezero.com",
]);

export function useIsBillingUser(): boolean {
  const { accessToken } = useAuthStore();
  const email = accessToken ? decodeAuthToken(accessToken)?.emailId ?? "" : "";
  return BILLING_USER_EMAILS.has(email.trim().toLowerCase());
}
